<template>
<div>
    <v-app v-show="isLoading">
        <loading />
    </v-app>
    <v-container v-show="!isLoading">
        <div class="categories-tree-view mt-3 ek-radius EK-shadow IMTOrange">
            <table class="w-100 white border-right">
                <thead>
                    <tr>
                        <th class="text">التصنيف</th>
                        <th style="width: 140px">عدد المشتركين</th>
                        <th style="width: 140px">إضافة تصنيف</th>
                        <th style="width: 140px">تفاصيل</th>
                    </tr>
                </thead>
                <tbody>
                    <v-treeview
                        :items="categoriesTree.children"
                        activatable
                        dense
                        return-object
                        expand-icon="mdi-chevron-down"
                        item-key="id"
                        color="IMThemeGray"
                    >
                        <template v-slot:prepend="{ item }">
                            <tr  :class="{ hidden : item.isHidden}">
                                <td
                                    @click="getChildren(item);"
                                    class="arrow"
                                    v-if="
                                        item.isParent && item.children == null
                                    "
                                >
                                    <v-btn icon>
                                        <v-icon>mdi-sync</v-icon>
                                    </v-btn>
                                </td>
                                <td class="text">{{ item.name }}</td>
                                <td style="width: 140px">{{ item.shopCount }}</td>
                                <td style="width: 140px">
                                    <v-btn @click="onConfirmAppend(item)" x-small icon style="background: #a59ead">
                                        <v-icon small>mdi-plus</v-icon>
                                    </v-btn>
                                </td>
                                <td style="width: 140px">
                                    <v-btn @click="onConfirmDetails(item)" text>
                                        <img
                                            src="/media/svg/table/detail.svg"
                                            alt="detail"
                                        />
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-treeview>
                </tbody>
            </table>
        </div>
        <template>
            <div class="text-center">
                <v-dialog v-model="dialog" scrollable width="500">
                    <actioCategory @close="closeDialog" :isCreate="isCreate"/>
                </v-dialog>
            </div>
        </template>
        <v-btn
            fab
            small
            class="position-fixed text-white"
            style="bottom: 40px; left:40px;"
            color="IMThemeGray"
            @click="onConfirmAppend(null)"
            ><v-icon small>mdi-plus</v-icon></v-btn
        >
    </v-container>
</div>
</template>
<style>
.hidden{
    opacity: 0.4;
}
</style>
<style lang="scss">
.categories-tree-view {
    overflow-x: auto;
    overflow-y: hidden;
    thead {
        border: solid 1px rgba(0, 0, 0, 0.12);
        background: #f9fafb;
    }
    .v-treeview {
        overflow: hidden;
    }
    tr {
        display: flex;
        td,
        th {
            padding: 12px;
            justify-content: center;
            display: flex;
            align-items: center;
            &.text {
                justify-content: end;
                padding-right: 62px;
                flex-grow: 1;
            }
            &.arrow {
                position: absolute;
                right: -46px;
                top: 6px;
            }
        }
    }
    .v-treeview-node__prepend {
        position: relative;
        margin-left: 0 !important;
        width: 100%;
        &:after {
            content: "";
            width: 2px;
            height: 62px;
            position: absolute;
            bottom: 30px;
            right: 0;
            background: #000;
        }
        &:before {
            content: "";
            width: 46px;
            height: 1px;
            position: absolute;
            bottom: 50%;
            right: 0;
            transform: translateY(-50%);
            background: #000;
            opacity: 1;
        }
    }
    .v-treeview-node__root {
        padding-right: 0;
        padding-left: 0;
        .v-treeview-node__level {
            height: 60px;
            width: 34px;
            position: relative;
        }
        .v-treeview-node__toggle {
            width: 34px;
            height: 34px;
        }
    }

    .v-treeview-node {
        .v-treeview-node__content {
            margin: 0;
        }
    }
    [aria-expanded="true"].v-treeview-node + .v-treeview-node > .v-treeview-node__root .v-treeview-node__prepend {
        &:after {
            height: 31px;
        }
    }
}
</style>
<script>
import actioCategory from "./components/action-category";
import loading from "@/components/loading";
import { mapGetters, mapActions } from "vuex";
export default {
    data: () => ({
        headers: [
            {
                text: "لتصنيف",
                value: "category",
                sortable: false
            },
            {
                text: "عدد المشتركين",
                value: "storeCount",
                sortable: false
            },
            {
                text: "إضافة تصنيف",
                value: "addCategory",
                sortable: false
            },
            {
                text: "تفاصيل",
                value: "info",
                sortable: false
            }
        ],
        dialog: false,
        isCreate: true
    }),
    components: {
        actioCategory,
        loading
    },
    created() {
        this.resetTree();
        this.getShopsCount();
        this.setBreadcrumbs([
            {
                text: "الإعدادت",
                disabled: false
            },
            {
                text: 'التصنيفات',
                disabled: false
            }]);
    },
    computed: {
        ...mapGetters(["categoriesTree", "modelCategory", "isLoading"])
    },
    methods: {
        ...mapActions(["fetchCategories", "setBreadcrumbs", "getShopsCount", "resetTree"]),
        getChildren(item) {
            item.children = [];
            this.fetchCategories(item.id);
        },
        onConfirmAppend(item) {
            const cat = {
                id: 0,
                name: null,
                isParent: false,
                isHidden: false,
                shopCount: 0,
                parentCategoryId: null,
                logo: [],
                image: []
            }
            if(!!item) {
                cat.parentCategoryId = item.id;
            }
            Object.assign(this.modelCategory, cat);
            this.isCreate = true;
            this.dialog = true;
        },
        onConfirmDetails(item){
            Object.assign(this.modelCategory, {
                id: item.id,
                name: item.name,
                isParent: item.isParent,
                children: item.children,
                isHidden: item.isHidden,
                shopCount: item.shopCount,
                parentCategoryId: item.parentCategoryId,
                logo: item.logo,
                image: item.image
            });
            this.isCreate = false;
            this.dialog = true;
        },
        closeDialog(){
            this.dialog = false;
        }
    }
};
</script>
